import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import TableApproveList from "./tableApproveList";
import { classifyLeaveStatus, isStatusEnabled } from "./historyStatusFilter";

const StyledWrapHistory = styled("div")({
  marginTop: 16,
});

function TableLeaveApproval(props) {
  const { searchName, filterStatus } = props;
  const { result: leaveEmployeesList } = useSelector(
    (state) => state.leaveEmployees
  );
  const { result: leaveEmployeeWithdrawsList } = useSelector(
    (state) => state.leaveEmployeesWithDraw
  );
  const [approvalSelected, setApprovalSelected] = useState([]);

  const dataTable = useMemo(() => {
    const leaves = Array.isArray(leaveEmployeesList) ? leaveEmployeesList : [];
    const withdraws = Array.isArray(leaveEmployeeWithdrawsList)
      ? leaveEmployeeWithdrawsList
      : [];

    return [...leaves, ...withdraws]
      .filter((x) => x.isApprove !== null)
      .filter((x) => isStatusEnabled(classifyLeaveStatus(x), filterStatus))
      .sort((a, b) => new Date(b.createDate) - new Date(a.createDate));
  }, [leaveEmployeesList, leaveEmployeeWithdrawsList, filterStatus]);

  return (
    <Box style={{ marginTop: 4 }}>
      <StyledWrapHistory>
        <div>
          <TableApproveList
            checkbox={false}
            dataTable={dataTable}
            approvalSelected={approvalSelected}
            setApprovalSelected={setApprovalSelected}
            searchName={searchName}
            showAttachment
          />
        </div>
      </StyledWrapHistory>
    </Box>
  );
}

export default TableLeaveApproval;
